import React from 'react';
import PropTypes from 'prop-types';
import Overlay from 'praece-react-bootstrap/lib/Overlay';
import Popover from 'praece-react-bootstrap/lib/Popover';

// Utils
import { stopPropagation, preventDefault } from 'utils/event-handlers';


export default class MenuOverlay extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    trigger: PropTypes.node
  };

  constructor() {
    super();

    this.state = { showPopover: false };

    this.show = () => this.setState({ showPopover: true });
    this.hide = () => this.setState({ showPopover: false });
  }

  render() {
    const { children, trigger } = this.props;
    const { showPopover } = this.state;

    return (
      <div onClick={preventDefault(this.show)} className="menu-overlay-trigger">
        {trigger}
        <Overlay
          rootClose
          show={showPopover}
          placement="bottom"
          target={this}
          onHide={this.hide}
        >
          <Popover
            id="ticket-options-window"
            className="clickable-options-list"
            onClick={stopPropagation()}
            onMouseOver={stopPropagation()}
          >
            <ul className="unstyled-list" onClick={this.hide}>
              {children}
            </ul>
          </Popover>
        </Overlay>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/widgets/overlays/menu.js